import { useState, useEffect } from 'react';
import { type Timestamp } from '../services/Timestamp';
import type React from 'react';

interface Props {
  children: React.ReactElement<any>;
  wait: Timestamp;
  shouldClearTimeout: boolean;
}

const Delayed = ({ children, wait, shouldClearTimeout }: Props): React.ReactElement<any> => {
  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisplayed(true);
    }, wait.toMilliseconds());
    if (shouldClearTimeout) {
      return (): void => {
        clearTimeout(timer);
      };
    }
  }, [wait]);

  return isDisplayed && children;
};

export default Delayed;
